import { Action } from '@ngrx/store';
import {MspRegion} from '../region.model';
import {Update} from '@ngrx/entity';

export enum RegionMspActionTypes {
  GetMspRegions = '[MspRegion] Get Msp Regions',
  UpdateMspRegion = '[MspRegion] Update Msp Region',
  AddMspRegion = '[MspRegion] Add Msp Region',
  GetMspRegionSuccess = '[MspRegion] Get Msp Region Success',
  LoadMspRegionFail = '[MspRegion] Load Msp Region Fail',
  TranslateMspDevice = '[MspRegion] Translate Msp Device',
}


export class GetMspRegions implements Action {
  readonly type = RegionMspActionTypes.GetMspRegions;
  constructor(public payload: any = null ) {}
}

export class UpdateMspRegion implements Action {
  readonly type = RegionMspActionTypes.UpdateMspRegion;
  constructor(public payload: Update<MspRegion> ) {}
}

export class GetMspRegionSuccess implements Action {
  readonly type = RegionMspActionTypes.GetMspRegionSuccess;
  constructor(public payload: MspRegion[]) {}
}

export class AddMspRegion implements Action {
  readonly type = RegionMspActionTypes.AddMspRegion;
  constructor(public payload: MspRegion ) {}
}

export class LoadMspRegionFail implements Action {
  readonly type = RegionMspActionTypes.LoadMspRegionFail;
  constructor(public payload: MspRegion ) {}
}
export class TranslateMspDevice implements Action {
  readonly type = RegionMspActionTypes.TranslateMspDevice;
  constructor(public payload: any = null ) {}
}

export type MspRegionActions = GetMspRegions
  | UpdateMspRegion
  | GetMspRegionSuccess
  | AddMspRegion
  | LoadMspRegionFail
  | TranslateMspDevice;


export enum MspRegionFilterActionTypes {
  SelectMspRegionFilters = '[MspRegionFilter] Select MspRegionFilters'
}

export class SelectMspRegionFilters implements Action {
  readonly type = MspRegionFilterActionTypes.SelectMspRegionFilters;
  constructor(public payload: number[]) {}
}

export type MspRegionFilterActions = SelectMspRegionFilters;
